module.exports = __webpack_public_path__ + "img/logo_akcea_therapeutics.6b59b0b2.png";